import { Component, OnInit } from "@angular/core";
import { FormBuilder, Validators } from "@angular/forms";
import { ItemService } from "src/app/shared/services/item/item.service";
import { Router, ActivatedRoute } from "@angular/router";
import { ItemModel } from "src/app/shared/models/item/item.modal";
import { ToastrService } from "ngx-toastr";
import { SettingService } from "src/app/shared/services/setting/setting.service";
import { HttpErrorResponse } from "@angular/common/http";

@Component({
  selector: "app-item-new",
  templateUrl: "./item-new.component.html",
  styleUrls: ["./item-new.component.scss"],
})
export class ItemNewComponent implements OnInit {
  public loading: boolean = false;
  public saveToProductLoader: boolean = false;
  public addMoreBtn: boolean = false;
  public submitted: boolean = null;
  public item_id: string = null;
  public transformedData: any = null;
  public tax_rate_list: any[] = [];
  public tax_exemption_list: any[] = [];

  public ItemModal: ItemModel = new ItemModel();

  constructor(
    public fb: FormBuilder,
    public ItemService: ItemService,
    public router: Router,
    public activatedRoute: ActivatedRoute,
    public toastr: ToastrService,
    public SettingService: SettingService
  ) {
    this.getItemList();
    this.getTaxRateList();
    this.getTaxExemptionList();
    this.item_id = this.activatedRoute.snapshot.paramMap.get("item_id");
    this.getItemDetails(this.item_id);
  }

  ngOnInit() {
    window.scroll(0, 0);
  }

  public NewItem = this.fb.group({
    name: ["", Validators.required],
    item_number: ["", Validators.required],
    description: ["", Validators.required],
    quantity: ["", [Validators.required, Validators.pattern("^[0-9]*$")]],
    rate: [
      "",
      [Validators.required, Validators.pattern("^[0-9]+(.[0-9]{0,2})?$")],
    ],
    video_url: [
      "",
      [
        Validators.pattern(
          /^(?:https?:\/\/)?(?:www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/
        ),
      ],
    ],
    is_active: [true],
    show_in_widget: [false],
    sku: [""],
    cost: ["", Validators.pattern(/^[0-9]+(\.[0-9]{1,2})?$/)],
    taxable: [0],
    tax_rate: [""],
    tax_exemption: [""],
    part_no: [""],
    model_no: [""],
    serial_no: [""],
  });

  get f() {
    return this.NewItem.controls;
  }

  getItemList() {
    this.loading = true;
    this.ItemService.GetItemList().subscribe(
      (result) => {
        this.loading = false;
        var item_number = result["data"].length + 1;
        this.digitFormatter(item_number);
      },
      (err: HttpErrorResponse) => {
        if (
          err.error.message == "Unauthenticated." ||
          err.status == 401 ||
          err.statusText == "Unauthorized"
        ) {
          this.SettingService.LogOut();
        }
      }
    );
  }

  digitFormatter(index: number) {
    let starting: any = `${index}`;
    let transformFormat = "00000";
    this.transformedData =
      transformFormat.substring(0, transformFormat.length - starting.length) +
      starting;

    this.NewItem.get("item_number").setValue(this.transformedData);
    this.NewItem.updateValueAndValidity();
    return this.transformedData;
  }

  getItemDetails(item_id) {
    if (item_id != null) {
      this.loading = true;
      this.ItemService.GetItemById(item_id).subscribe(
        (result) => {
          this.loading = false;

          this.ItemModal.item_id = result["data"].item_id;
          this.ItemModal.name = result["data"].name;
          this.ItemModal.description = result["data"].description;
          this.ItemModal.quantity = result["data"].quantity;
          this.ItemModal.rate = result["data"].rate;
          this.ItemModal.video_url = result["data"].video_url;
          this.ItemModal.is_active = result["data"].is_active;
          this.NewItem.get("item_number").setValue(result["data"].item_number);
          this.NewItem.updateValueAndValidity();
          this.ItemModal.item_number = result["data"].item_number;
          this.ItemModal.sku = result["data"].sku;
          this.ItemModal.cost = result["data"].cost;
          this.ItemModal.tax_rate = result["data"].tax_rate;
          this.ItemModal.tax_exemption = result["data"].tax_exemption;
          this.ItemModal.model_no = result["data"].model_no;
          this.ItemModal.serial_no = result["data"].serial_no;
          this.ItemModal.part_no = result["data"].part_no;
          this.ItemModal.show_in_widget = result["data"].show_in_widget;
        },
        (err: HttpErrorResponse) => {
          if (
            err.error.message == "Unauthenticated." ||
            err.status == 401 ||
            err.statusText == "Unauthorized"
          ) {
            this.SettingService.LogOut();
          }
        }
      );
    } else {
      this.loading = false;
    }
  }

  SaveItem() {
    this.submitted = true;
    if (
      this.NewItem.value.is_active === "" ||
      this.NewItem.value.is_active === null
    ) {
      this.NewItem.value.is_active = false;
    }

    if (
      this.NewItem.value.show_in_widget === "" ||
      this.NewItem.value.show_in_widget === null
    ) {
      this.NewItem.value.show_in_widget = false;
    }

    if (this.NewItem.invalid) {
      return;
    }
    this.saveToProductLoader = true;
    if (this.item_id == null) {
      // this.NewItem.value.rate = this.NewItem.value.rate.substring(1);
      this.ItemService.AddItem(this.NewItem.value).subscribe(
        (result) => {
          if (result["success"]) {
            this.showSuccess(result["msg"]);
            this.router.navigate(["/products"]);
          } else {
            this.showDanger(result["msg"]);
          }
          this.saveToProductLoader = false;
        },
        (err: HttpErrorResponse) => {
          if (
            err.error.message == "Unauthenticated." ||
            err.status == 401 ||
            err.statusText == "Unauthorized"
          ) {
            this.SettingService.LogOut();
            this.saveToProductLoader = false;
          }
        }
      );
    } else {
      // this.ItemModal.rate= this.ItemModal.rate.substring(1);
      this.ItemService.UpdateItem(this.ItemModal).subscribe(
        (result) => {
          if (result["success"]) {
            this.showSuccess(result["msg"]);
            this.router.navigate(["/products"]);
          } else {
            this.showDanger(result["msg"]);
          }
        },
        (err: HttpErrorResponse) => {
          if (
            err.error.message == "Unauthenticated." ||
            err.status == 401 ||
            err.statusText == "Unauthorized"
          ) {
            this.SettingService.LogOut();
          }
        }
      );
    }
  }

  SaveItemAndMore() {
    this.submitted = true;

    // if (
    //   this.NewItem.value.is_active === "" ||
    //   this.NewItem.value.is_active === null
    // ) {
    //   this.NewItem.value.is_active = false;
    // }
    if (
      this.NewItem.value.show_in_widget === "" ||
      this.NewItem.value.show_in_widget === null
    ) {
      this.NewItem.value.show_in_widget = false;
    }


    if (this.NewItem.invalid) {
      return;
    }
    this.addMoreBtn = true;
    if (this.item_id == null) {
      // this.NewItem.value.rate = this.NewItem.value.rate.substring(1);
      this.ItemService.AddItem(this.NewItem.value).subscribe(
        (result) => {
          if (result["success"]) {
            this.showSuccess(result["msg"]);
            this.submitted = false;

            this.NewItem.reset();
            this.NewItem.get('is_active').setValue(true);
            this.NewItem.get('is_active').updateValueAndValidity();
            this.submitted = false;
          } else {
            this.showDanger(result["msg"]);
          }
          this.addMoreBtn = false;
        },
        (err: HttpErrorResponse) => {
          if (
            err.error.message == "Unauthenticated." ||
            err.status == 401 ||
            err.statusText == "Unauthorized"
          ) {
            this.SettingService.LogOut();
            this.addMoreBtn = false;
          }
        }
      );
    } else {
      // this.ItemModal.rate= this.ItemModal.rate.substring(1);
      this.ItemService.UpdateItem(this.ItemModal).subscribe(
        (result) => {
          if (result["success"]) {
            this.submitted = false;

            this.showSuccess(result["msg"]);
            this.NewItem.reset();
            this.submitted = false;
          } else {
            this.showDanger(result["msg"]);
          }
          this.addMoreBtn = false;
        },
        (err: HttpErrorResponse) => {
          if (
            err.error.message == "Unauthenticated." ||
            err.status == 401 ||
            err.statusText == "Unauthorized"
          ) {
            this.SettingService.LogOut();
            this.addMoreBtn = false;
          }
        }
      );
    }
  }

  getTaxRateList() {
    this.SettingService.GetTaxRates().subscribe((result) => {
      this.tax_rate_list = result["data"];
    });
  }

  getTaxExemptionList() {
    this.SettingService.GetTaxExemptionList().subscribe((result) => {
      this.tax_exemption_list = result["data"];
    });
  }

  showSuccess(msg: string) {
    this.toastr.success(msg);
  }

  showDanger(msg: string) {
    this.toastr.error(msg);
  }
}
